// src/services/admin/admin-transactionService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const adminTransactionApi = axios.create({
  baseURL: `${API_URL}/api/v1/admin/transactions`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
});

adminTransactionApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminTransactionService = {
  async getTransactions(params = {}) {
    const res = await adminTransactionApi.get('/', { params });
    return res.data;
  },

  async getStats() {
    const res = await adminTransactionApi.get('/stats');
    return res.data;
  },

  async getTransactionById(id) {
    const res = await adminTransactionApi.get(`/${id}`);
    return res.data;
  },

  async updateStatus(id, status) {
    const res = await adminTransactionApi.patch(`/${id}/status`, { status });
    return res.data;
  }
};

export default adminTransactionService;